const c = {
  name: "Click",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29,13c-2.8,0-5,2.2-5,5h-2c0-3.9,3.1-7,7-7V13z"/>
		<path class="st0" d="M20,18c0-5,4-9,9-9V7c-6.1,0-11,4.9-11,11H20z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v19c0,1.7,1.3,3,3,3h23v3.9l-1.4-1.4c-0.6-0.6-1.3-0.9-2.1-0.9c-0.8,0-1.5,0.3-2.1,0.9
			c-1.2,1.2-1.2,3.1,0,4.2l8.2,8.2H40V27.3L34.4,25H37c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M32,23v-5c0-0.8-0.3-1.6-0.9-2.1
			C30.6,15.3,29.8,15,29,15c-1.7,0-3,1.3-3,3v5H3c-0.5,0-1-0.5-1-1V3c0-0.5,0.5-1,1-1h34c0.5,0,1,0.5,1,1v19c0,0.5-0.5,1-1,1H32z
			 M28,18c0-0.5,0.5-1,1-1c0.3,0,0.5,0.1,0.7,0.3l0,0l0,0c0.2,0.2,0.3,0.4,0.3,0.7v7.4l8,3.3V38h-8.6l-7.6-7.6c-0.4-0.4-0.4-1,0-1.4
			c0.2-0.2,0.5-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3l3.1,3.1l1.7-1.7V18z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Click
};
